"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerType = void 0;
var BannerType;
(function (BannerType) {
    BannerType["INCIDENT"] = "incident";
    BannerType["INFORMATIONAL"] = "informational";
    BannerType["MARKETING"] = "marketing";
})(BannerType = exports.BannerType || (exports.BannerType = {}));
